import { NgModule } from '@angular/core';
import { OrganisationMenuComponent } from './header/organisation-menu/organisation-menu.component';
import { SharedModule } from '../shared.module';
import { CintraCloudLogoComponent } from './cintra-cloud-logo/cintra-cloud-logo.component';
import { AuthLayoutComponent } from './auth-n/layout/auth-layout.component';
import { SignInComponent } from './auth-n/sign-in/sign-in.component';
import { AuthenticationComponentsModule } from '@auth-n/authentication-components.module';
import { BannersModule } from '@app/app-layout/banners/banners.module';
import { EquifaxDisclosureAcknowledgementComponent } from '@organisations/equifax/equifax-disclosure-acknowledgement.component';
import { ResetPasswordComponent } from '@app/app-layout/auth-n/reset-password/reset-password.component';
import { EmploymentMenuComponent } from '@app/app-layout/header/employment-menu/employment-menu.component';
import { BureauMenuComponent } from '@app/app-layout/header/bureau-menu/bureau-menu.component';
import { NewAppLayoutComponent } from '@app/app-layout/new-layout/new-app-layout.component';
import { RightSidebarComponent } from './right-sidebar/right-sidebar.component';
import { AppShellComponent } from '@component-library/layout';

const standalone = [OrganisationMenuComponent, EmploymentMenuComponent, BureauMenuComponent, SignInComponent, ResetPasswordComponent];

@NgModule({
  declarations: [EquifaxDisclosureAcknowledgementComponent],
  imports: [
    SharedModule,
    AuthenticationComponentsModule,
    BannersModule,
    // Import standalone components
    AppShellComponent,
    NewAppLayoutComponent,
    RightSidebarComponent,
    AuthLayoutComponent,
    CintraCloudLogoComponent,
    ...standalone
  ],
  exports: [NewAppLayoutComponent, SignInComponent, AuthLayoutComponent, CintraCloudLogoComponent]
})
export class AppLayoutModule {}
